export default __webpack_public_path__ + "static/media/sampleReport4.fbdc66b0.png";